import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { PlatformCard } from '../PlatformCard';

import { Loading } from './Loading';

import { IntradayContainerContentProps } from '.';

export const ContentDesktop: React.FC<IntradayContainerContentProps> = ({
  tradingList,
  accountId,
  accountPNP,
  sinacor,
  tradingListLoading,
}) => {
  return (
    <VStack
      py={Spacing['inset.sm']}
      borderRadius={'md'}
      width={'100%'}
      justifyContent={'space-between'}>
      {!tradingListLoading &&
        tradingList?.length &&
        tradingList.map((item) => (
          <PlatformCard
            id={item.id}
            tradings={item.tradingsConsolidate}
            key={item.id.toString()}
            tradingListLoading={tradingListLoading}
            idConta={accountId}
            idContaSuperPNP={accountPNP}
            sinacor={sinacor}
          />
        ))}
      {tradingListLoading && <Loading />}
    </VStack>
  );
};
